import React from 'react'
import { Link } from "react-router-dom"

const Hot = () => {
  return (
    <div>Hot</div>
  )
}

export default Hot;
